import React from 'react';
import { Button } from "../ui/button";
import { Sparkles, Linkedin, Mail } from 'lucide-react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

export default function Contact() {
    const navigate = useNavigate();

    return (
        <section id="contacto" className="py-24">
            <div className="max-w-4xl mx-auto px-6">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                >
                    <div className="text-center mb-10">
                        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-green-400 mb-4">
                            Tu próximo paso
                        </h2>
                        <p className="text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto">
                            Respondé 4 preguntas rápidas y te digo cómo empezar. Sin compromiso.
                        </p>
                    </div>

                    <div className="flex flex-col items-center gap-6">
                        {/* CTA principal — mismo que Hero */}
                        <Button
                            size="lg"
                            onClick={() => navigate('/Inicia')}
                            className="bg-green-600 hover:bg-green-700 text-white px-8 py-5 text-base sm:text-lg rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                        >
                            <Sparkles className="mr-2 w-5 h-5" />
                            Contactame y empecemos
                        </Button>

                        {/* Secundarios — discretos */}
                        <div className="flex items-center gap-4 text-sm text-gray-500">
                            <span>o escribime directo:</span>
                            <a
                                href="https://www.linkedin.com/in/luciano-argolo/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-green-400 hover:text-green-300 transition-colors flex items-center gap-1"
                            >
                                <Linkedin className="w-4 h-4" /> LinkedIn
                            </a>
                            <span className="text-gray-600">·</span>
                            <a
                                href="https://mail.google.com/mail/?view=cm&fs=1&to=LucianoAgustinArgolo@gmail.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-green-400 hover:text-green-300 transition-colors flex items-center gap-1"
                            >
                                <Mail className="w-4 h-4" /> Email
                            </a>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
